import { ApplicationProfileMetadata } from '@amzn/snow-data-service-typescript-client';
import { getFullDateFromEpoch } from 'src/utils/CommonUtils';

export interface KeyValueItem {
	label: string;
	value: string;
}

export interface ApplicationDetailsItems {
	applicationInfoItems: KeyValueItem[];
	classificationItems: KeyValueItem[];
}

export const getApplicationDetailsItems = (
	applicationData: ApplicationProfileMetadata
): ApplicationDetailsItems => {
	const baseItems: KeyValueItem[] = [
		{ label: 'Application ID', value: applicationData.applicationId || '' },
		{ label: 'Application Name', value: applicationData.applicationName || '' },
		{ label: 'Description', value: applicationData.description || '' },
		{ label: 'Status', value: applicationData.status || '' },
		{ label: 'Owner', value: applicationData.owner || '' },
	];
	const subdomainItems: KeyValueItem[] =
		applicationData.subDomains && applicationData.subDomains.length > 0
			? [ { label: 'Subdomains', value: applicationData.subDomains.join(', ') } ] : [];

	const timestampItems: KeyValueItem[] = [
		{ label: 'Created By', value: applicationData.createdBy || '' },
		{ label: 'Last Updated By', value: applicationData.lastUpdatedBy || '' },
		{ label: 'Creation Time', value: getFullDateFromEpoch(applicationData.createdAt) },
		{ label: 'Last Update Time', value: getFullDateFromEpoch(applicationData.lastUpdatedAt) },
	];

	const applicationInfoItems = [
		...baseItems,
		...subdomainItems,
		...timestampItems,
	];

	const classificationItems: KeyValueItem[] = applicationData.cti
		? [
			{ label: 'Category', value: applicationData.cti.category || '' },
			{ label: 'Type', value: applicationData.cti.type || '' },
			{ label: 'Item', value: applicationData.cti.item || '' },
			{ label: 'Bindle ID', value: applicationData.bindleId || '' },
			{ label: 'Domain', value: applicationData.domain || '' },
		  ]
		: [];

	return {
		applicationInfoItems,
		classificationItems,
	};
};
